import { render, staticRenderFns } from "./SettingsGeneralPanel.vue?vue&type=template&id=186a9d3c"
import script from "./SettingsGeneralPanel.vue?vue&type=script&lang=ts"
export * from "./SettingsGeneralPanel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports